import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';

import { UiModalDefaultComponent } from '@unico-people/shared/dashboard/ui-modal-default';
@Component({
  selector: 'unico-people-employee-import',
  templateUrl: './employee-import.component.html',
  styleUrls: ['./employee-import.component.scss']
})
export class EmployeeImportComponent {
  dialogDefault: MatDialogRef<UiModalDefaultComponent>;
  collaborator = {
    kind: 'collaborators',
    text: 'colaboradore',
    urlModel: 'https://storage.googleapis.com/dev-collaborator-acessorh-com-br/files/modelo-colaboradores.csv',
    fields: [
      'Nome',
      'CPF',
      'Vínculo',
      'Código',
      'E-mail',
      'Celular',
      'Salário',
      'Situação',
      'Data admissão',
      'Data nasc.',
      'Nome do líder',
      'E-mail do líder',
      'Crédito',
    ],
    fieldsSlug: [
      'name',
      'cpf',
      'relation',
      'employee_code',
      'email',
      'phone',
      'salary',
      'state',
      'admission_date',
      'birthdate',
      'leaderEmail',
      'leaderName',
      'credit'
    ]
  };
  constructor(public dialog: MatDialog, public router: Router, private segment: TrackingSegmentService) {}

  cancelImport(): void {
    this.dialogDefault = this.dialog.open(UiModalDefaultComponent, {
      disableClose: false
    });
    this.dialogDefault.componentInstance.confirmMessage = 'Deseja sair da importação de colaboradores?';
    this.dialogDefault.componentInstance.menssageSubtitle = 'As informações inseridas até aqui não serão salvas.';

    this.dialogDefault.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigateByUrl('/');
      }
    });
  }
}
